import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Card, Col, Row } from 'react-bootstrap';
import Badge from 'components/base/Badge';

interface CrmStatCardProps {
  icon: IconProp;
  color: string;
  label: string;
  title: string;
  value: number;
  value2: number;
  value3: number;
}

const HVASystemKPICard1Inbound = ({
  icon,
  color,
  label,
  title,
  value,
  value2,
  value3
}: CrmStatCardProps) => {
  const formattedValue2 = `${value2.toFixed(1)}%`; // Formatear value2 como porcentaje con un decimal
  const minutes = Math.floor(value3);
  const seconds = Math.round((value3 - minutes) * 60);
  const formattedValue3 = `${minutes}m:${seconds}s`; // Formatear value3 como minutos y segundos

  return (
    <Card className="bg-primary-dark text-light">
      <Card.Body className="p-2 pt-0 pb-1">
        <Row className="mb-0 border-bottom">
          <Col
            className="d-flex align-items-center text-start px-0"
            xs={7}
            sm={7}
            md={7}
            xl={7}
            xxl={7}
          >
            <div
              className={`d-flex justify-content-center align-items-center pt-1`}
              style={{ width: '30px', minWidth: '30px' }}
            >
              <FontAwesomeIcon
                icon={icon}
                className={`text-${color} fs-7 z-1 ms-2`}
                shake={true}
              />
            </div>
            <p className="text-light fs-11 mb-0 ms-2 mt-2 lh-1">
              {label} <br />
              <span className="p-0 fs-8 fw-bold lh-1 text-highlight">
                {title}
              </span>
            </p>
          </Col>
          <Col
            className={`text-${color} mt-2 p-0 fs-7 fw-bold mb-0 pt-1 text-end`}
            xs={5}
            sm={5}
            md={5}
            xl={5}
            xxl={5}
          >
            {value}
          </Col>
        </Row>
        <Row>
          <span className="mb-0 mt-0 p-0 pt-1">
            <p className="text-light fs-9 mb-0 text-end">
              % of handled calls:{' '}
              <span className="fs-8 text-end">
                <Badge bg="secondary" variant="phoenix">
                  {formattedValue2}
                </Badge>
              </span>
            </p>
          </span>
          <span className="mb-0 mt-0 p-0">
            <p className="text-light fs-9 mb-1 p-0 lh-sm text-end">
              Average talk time:{' '}
              <span className="fs-8 text-end">
                <Badge bg="secondary" variant="phoenix">
                  {formattedValue3}
                </Badge>
              </span>
            </p>
          </span>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default HVASystemKPICard1Inbound;
